/**
 * GZOO AI Marketing - Frontend
 * Home Page - Redirects to login or dashboard based on auth state
 */

'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

export default function Home() {
  const router = useRouter();

  useEffect(() => {
    const token = localStorage.getItem('access_token');
    if (token) {
      router.replace('/dashboard');
    } else {
      router.replace('/login');
    }
  }, [router]);

  // Show nothing while redirecting
  return null;
}
